import {  ITopics, messagesResult,  seenMessages,  ITopic,  topicsResult } from "../types";

const queryString = content => new URLSearchParams(content).toString()
interface IfetchWordpress {
    route: string,
    query: any,
    method?: 'GET' | "POST" | "PUT" | "DELETE",
    additional?: any | undefined
}
const fetchWordpress = async ({ route, query = null, method = 'GET', additional = {} }:IfetchWordpress) => {
    try {
        const res = await fetch(
            chat_data?.root + route + (query ? `?${queryString(query)}` : ''),
            {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': chat_data?.nonce,
                },
                ...additional
            }
        );
        const resBody = await  res.text()
        return res.ok ? JSON.parse(resBody) : Promise.reject('خطای شبکه')
    } catch (e) {
        return Promise.reject(e)

    }
}

export const userFetcher = async (route: string, query: any) => {
    try {
        const res = await fetchWordpress({ route, query })
        if (res["success"]) {
            return res["data"]
        }
    } catch (e) {
        throw new Error(e)
    }
}
export const getTopicUsers = async(topic_id:number)=>{
    try {
        const res = await fetchWordpress({ route: "dusco/v1/users/" + topic_id, query: "" })
        return res
    } catch (e) {
        throw new Error(e);
    }
}
export const topicCreator = async(other_userid:number,query:any)=>{
    const body = JSON.stringify({ other_userid })
    try {
        const res = await fetchWordpress({ route: "dusco/v1/topics", query: query, method: "POST", additional: { body: body } })
        return res
    } catch (e) {
        throw new Error(e);
    }
}

export const updateMessages = async (messageIds:number[],topic_id:number) => {

    const res: seenMessages = await fetchWordpress({
        route: "dusco/v1/messages/seen/", method: "POST", additional: {
            body: JSON.stringify({ "messages": messageIds, "topic_id": topic_id }),
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': chat_data?.nonce,
            },

        }, query: {}
    })
    return res
}
export const topicsFetcher = async (route: string, query: any) => {
    try {
        const res:topicsResult = await fetchWordpress({ route, query })
        console.log(res)
        if (res.result && res.topics) {
            return res.topics
        } else if (res.code == 'empty') {
            return [];
        } else {
            const error = new Error('خطای شبکه')
            error.name = res.code ?? "خطای غیر منتظره"
            throw error
        }
    } catch (e) {
        throw new Error(e)
    }
}

export const addGroup = async (topic_id: number,user_id:number[],content:string) => {
    const body = JSON.stringify({ "other_userid": user_id, "topic_id": topic_id })
    const res = await fetchWordpress({ route: "dusco/v1/topics/group/"+content, method: "PUT", query: {}, additional: { body } })
    debugger; console.log(res)
    if (res.result && res.message) {
        return res
    } else {
        throw new Error(res.message)
    }

}
export const removeGroup = async (topic_id: number) => {
    const res = await fetchWordpress({ route: "dusco/v1/topics/group/remove/" + topic_id, method: "DELETE", query: {} })
    debugger; console.log(res)
    if (res.result && res.message) {
        return res
    } else {
        throw new Error(res.message)
    }

}
export const deleteGroup = async (topic_id: number, user_id: number, content: string) => {
    const body = JSON.stringify({ "other_userid": user_id, "topic_id": topic_id })
    const res = await fetchWordpress({ route: "dusco/v1/topics/groups/" + content, method: "DELETE", query: {}, additional: { body } })
    debugger; console.log(res)
    if (res.result && res.message) {
        return res
    } else {
        throw new Error(res.message)
    }

}

export const deleteGroups = async (topic_id: number, user_id: number, content: string) => {
    const body = JSON.stringify({ "other_userid": user_id, "topic_id": topic_id })
    const res = await fetchWordpress({ route: "dusco/v1/topics/groups/" + content, method: "DELETE", query: {}, additional: { body } })
    if (res.result && res.message) {
        return res
    } else {
        throw new Error(res.message)
    }

}

export const editMessage = async (content: string, message_id: number,text:string ) => {
    const body = JSON.stringify({ text })
    const res: messagesResult = await fetchWordpress({ route: "dusco/v1/messages", method: "PUT", query: { content, message_id }, additional: { body } })

    if (res.result && res.messages) {
        return res.messages
    } else {
        throw new Error('no response')
    }

}
export const removeMessage = async (content: string, message_id: number) => {
    const res = await fetchWordpress({ route: "dusco/v1/messages/" + message_id, method: "DELETE", query: { content } })
    if (res.result && res.messages) {
        return res.messages
    } else {
        throw new Error('no response')
    }

}
export interface ISendRequest{
    text: string,
    content: string
}
export const messageFetcher = async (content: string, url: string, before) => {
    const res: messagesResult = await fetchWordpress({ route: url, query: { content, before } })
    console.log(" messages ", res)
    if (res.result && res.messages) {
        return res.messages
    } else {
        throw new Error('no response')
    }

}
export interface ISendRequest{
    text: string,
    content: string
}
export const sendRequest = async (route: string, { text, content }: ISendRequest) => {
    const formData = new FormData()
    formData.append('text', text)
    formData.append('content',content)
    try {
        const res = await fetch(
            chat_data?.root + route,
            {
                method: 'POST',
                headers: {
                    'X-WP-Nonce': chat_data?.nonce,
                },
                body: formData
            }
        )
        return res.ok ? res.json() : Promise.reject('خطای شبکه')
    } catch (err) {
        console.error('Error:', err)
        return { result: false }
    }
}


export const sendPost = async (route, { arg: { formData } }) => {
    return await fetch(
        rest.root + route,
        {
            method: 'POST',
            headers: {
                'X-WP-Nonce': rest.nonce,
            },
            body: formData
        }
    ).then(res => res.ok ? res.json() : Promise.reject('خطای شبکه'))
}

// When using await trigger
export const sendPost2 = async (route, { arg: { formData } }) => {
    return await fetch(
        rest.root + route,
        {
            method: 'POST',
            headers: {
                'X-WP-Nonce': rest.nonce,
            },
            body: formData
        }
    ).then(res => res.ok ? res.json() : Promise.reject('خطای شبکه'))
        .then(res => res.result || res.success ? res : Promise.reject(res))
}

// When using trigger without await
export const sendPost3 = async (route: string, argument: { arg: { json: boolean, formData: FormData } }) => {
    const { arg } = argument || {}
    const { formData, json } = arg || {}

    const res = await fetch(
        rest.root + route,
        {
            method: 'POST',
            headers: {
                'X-WP-Nonce': rest.nonce,
                ...(json ? { 'Content-Type': 'application/json' } : {})
            },
            body: json ? JSON.stringify(json) : formData ?? new FormData()
        }
    )
    return res.ok ? res.json() : Promise.reject('خطای شبکه');
}


export const getFetcher = async (arg) => {
    const [route, params] = Array.isArray(arg) ? arg : [arg, undefined]
    const fullRoute = params ? addQueryArgs(route, params) : route

    return await fetch(
        rest.root + fullRoute,
        {
            method: 'GET',
            headers: {
                'X-WP-Nonce': rest.nonce,
            },
        }
    ).then(res => res.ok ? res.json() : Promise.reject('خطای شبکه'))
        .then(res => res.result || res.success ? res : Promise.reject(res))
        .then(res => res.data || res)
}


export const wordpressSendPost = async (route, { arg: { formData } }) => {
    return await fetch(
        rest.root + route,
        {
            method: 'POST',
            headers: {
                'X-WP-Nonce': rest.nonce,
            },
            body: formData
        }
    )
        .then(res => res.ok ? res.json() : Promise.reject('خطای شبکه'))
        .then(res => res.success ? res : Promise.reject(res))
}
